import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import { Tooltip } from 'antd';
import moment, { ISO_8601 } from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { Avatar } from 'components/atoms/avatar';
import { Popover } from 'components/atoms/popover';
import { selectActiveStatusUpdate } from 'data/status-updates';
import { useGetAllMembersInProject } from 'hooks/use-idb';
import { useTranslate } from 'hooks/use-translation';
import { fullName } from 'utils/full-name';
import {
  CCContentWrapper,
  CCPopoverContent,
  CCPopoverWrapper,
  CCWrapper,
  FlexWrapper,
  PublishedBy,
  PublishedDate,
  Spacer,
  Username,
} from './styles';

export const SentToInfo = ({ projectId }) => {
  const translate = useTranslate();
  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);
  const usersInProject = useGetAllMembersInProject({
    projectId: projectId?.[1],
    isPrivate: activeStatusUpdate?.private,
  });

  if (!activeStatusUpdate || !activeStatusUpdate?.publishedBy) {
    return <span />;
  }

  const usersInProjectEmails = usersInProject.map((usr) => usr.emailId);

  const toUserMails = (activeStatusUpdate.toUsers ?? []).map(
    (usr) => usr.emailId,
  );

  const ccUserMails = (activeStatusUpdate.ccUsers ?? []).map(
    (_usr) => _usr.emailId,
  );

  const allUsersPresent = usersInProjectEmails.every((mailId) =>
    toUserMails.includes(mailId),
  );

  const displayEmails = [
    ...(allUsersPresent ? [translate('su.all.project.members')] : toUserMails),
    ...ccUserMails,
  ];

  const author = activeStatusUpdate.publishedBy;
  const publishedDate = moment(activeStatusUpdate.publishedAt, ISO_8601).format(
    'ddd, MMM DD',
  );
  const name = fullName(author);

  const EmailCCPopover = () => {
    return (
      <CCPopoverWrapper>
        <CCPopoverContent>
          <div>{`${translate('su.email.from')} :`}</div>{' '}
          <PublishedBy>{activeStatusUpdate.publishedBy?.emailId}</PublishedBy>
        </CCPopoverContent>
        <CCPopoverContent>
          <Spacer>{`${translate('su.email.to')} :`}</Spacer>
          <div>
            {displayEmails.map((emailId) => (
              <div>{emailId}</div>
            ))}
          </div>
        </CCPopoverContent>
      </CCPopoverWrapper>
    );
  };

  return (
    <FlexWrapper>
      <CCWrapper>
        <Avatar src={author.photoUrl} name={name} />
        <div>
          <div>
            <Tooltip title={name}>
              <Username ellipsis>{name}</Username>
            </Tooltip>
          </div>
          <div>
            {displayEmails.length ? (
              <Popover
                content={<EmailCCPopover />}
                trigger="hover"
                placement="bottom"
              >
                <CCContentWrapper>
                  {`${translate('su.email.to')} ${displayEmails
                    .slice(0, 2)
                    .map((emailId) => emailId)
                    .join(', ')}`}
                  <CaretDown16 />
                </CCContentWrapper>
              </Popover>
            ) : null}
          </div>
        </div>
      </CCWrapper>

      <PublishedDate>{publishedDate}</PublishedDate>
    </FlexWrapper>
  );
};
